/// <amd-module name="Artifacts/Root/redux/Reducer" />

import { ReadyComponentState } from "Artifacts/Root/helpers/ComponentStateHelpers";
import { syncComponentState } from "Artifacts/Root/Redux";
import {
  IAddOrEditOrDeleteViewPayload,
  IHideFeedMessagePayload,
  IResolveFeedPayload,
  IResolveViewPayload,
  IShowFeedMessagesPayload,
  IShowModalPayload,
  RootActions,
  RootActionTypes,
} from "Artifacts/Root/redux/Actions";
import { IRootState } from "Artifacts/Root/redux/Contracts";
import produce from "immer";

const initialState = (): IRootState => ({
  feed: undefined,
  promoteCommandState: ReadyComponentState(),
  permDeleteCommandState: ReadyComponentState(),
  softDeleteCommandState: ReadyComponentState(),
  unlistRelistCommandState: ReadyComponentState(),
  restoreCommandState: ReadyComponentState(),
  deprecateCommandState: ReadyComponentState(),
});

export const rootReducer = produce((draft: IRootState, action: RootActions) => {
  syncComponentState(draft, "promoteCommandState", action, {
    loading: RootActionTypes.PromoteCommandStarted,
    ready: RootActionTypes.PromoteCommandCompleted,
    error: RootActionTypes.PromoteCommandFailed,
  });
  syncComponentState(draft, "permDeleteCommandState", action, {
    loading: RootActionTypes.PermDeleteCommandStarted,
    ready: RootActionTypes.PermDeleteCommandCompleted,
    error: RootActionTypes.PermDeleteCommandFailed,
  });
  syncComponentState(draft, "softDeleteCommandState", action, {
    loading: RootActionTypes.SoftDeleteCommandStarted,
    ready: RootActionTypes.SoftDeleteCommandCompleted,
    error: RootActionTypes.SoftDeleteCommandFailed,
  });
  syncComponentState(draft, "unlistRelistCommandState", action, {
    loading: RootActionTypes.UnlistRelistCommandStarted,
    ready: RootActionTypes.UnlistRelistCommandCompleted,
    error: RootActionTypes.UnlistRelistCommandFailed,
  });
  syncComponentState(draft, "restoreCommandState", action, {
    loading: RootActionTypes.RestoreCommandStarted,
    ready: RootActionTypes.RestoreCommandCompleted,
    error: RootActionTypes.RestoreCommandFailed,
  });
  syncComponentState(draft, "deprecateCommandState", action, {
    loading: RootActionTypes.DeprecateCommandStarted,
    ready: RootActionTypes.DeprecateCommandCompleted,
    error: RootActionTypes.DeprecateCommandFailed,
  });
  switch (action.type) {
    case RootActionTypes.ResolveFeed:
      draft.feed = (action.payload as IResolveFeedPayload).feed;
      break;
    case RootActionTypes.ResolveView:
      if (draft.feed) {
        draft.feed.selectedViewId = (action.payload as IResolveViewPayload).view?.id;
      }
      break;
    case RootActionTypes.ShowFeedMessages:
      if (draft.feed && draft.feed?.feedMessages) {
        const currentMessages = draft.feed.feedMessages;
        const newFeedMessages = (action.payload as IShowFeedMessagesPayload).feedMessages.filter(
          (x) => currentMessages.findIndex((m) => m.id === x.id) < 0,
        );
        draft.feed.feedMessages = [...draft.feed.feedMessages, ...newFeedMessages];
      } else if (draft.feed) {
        draft.feed.feedMessages = (action.payload as IShowFeedMessagesPayload).feedMessages;
      }
      break;
    case RootActionTypes.HideFeedMessage:
      if (draft.feed?.feedMessages) {
        const index = (action.payload as IHideFeedMessagePayload).messageIndex;
        draft.feed.feedMessages.splice(index, 1);
      }
      break;
    case RootActionTypes.ShowModal:
      draft.modal = (action.payload as IShowModalPayload).modal;
      break;
    case RootActionTypes.HideModal:
      draft.modal = undefined;
      draft.promoteCommandState = ReadyComponentState();
      draft.permDeleteCommandState = ReadyComponentState();
      draft.softDeleteCommandState = ReadyComponentState();
      draft.unlistRelistCommandState = ReadyComponentState();
      draft.restoreCommandState = ReadyComponentState();
      break;
    case RootActionTypes.FakeAddOrEditView:
      if (draft.feed?.views) {
        const views = draft.feed.views.filter(
          (x) => x.id !== (action.payload as IAddOrEditOrDeleteViewPayload).view.id,
        );
        views.push((action.payload as IAddOrEditOrDeleteViewPayload).view);
        // Sort views alphabetically so they match server
        const sortedViews = views.sort((a, b) => a.name.localeCompare(b.name, navigator.language));
        draft.feed.views = sortedViews;
      }
      break;
    case RootActionTypes.FakeDeleteView:
      if (draft.feed?.views) {
        draft.feed.views = draft.feed.views.filter(
          (x) => x.id !== (action.payload as IAddOrEditOrDeleteViewPayload).view.id,
        );
      }
      break;
  }
  return draft;
}, initialState());
